import { extendBfldrCacheTime } from "../../../../wpl/image/src/image";

import { ImageProps } from "./image-props";

export const AssigneeBlake24Image = (props: ImageProps) => {
    const src = extendBfldrCacheTime(
        "https://dam-cdn.atl.orangelogic.com/AssetLink/gtou8x0538yr0283q5f5ph4a1qtx16c1.svg"
    );
    return (
        // eslint-disable-next-line no-restricted-syntax
        <img
            height={24}
            width={24}
            alt={props.alt}
            src={src}
            data-testid={props["data-testid"]}
            className={props.className}
        />
    );
};
